import React, { useMemo } from "react";
import { searchComposer } from "ReactReducers/Search/search-composer";
import { productListComposer } from "ReactReducers/ProductList/product-list-composer";
import Tabs from "ReactComponents/Tabs/tabs";
import Tab from "ReactComponents/Tabs/tab";
import SearchBox from "ReactComponents/Search/search-box";
import ProductSearchResults from "ReactComponents/Search/product-search-results";
import ContentSearchResults from "ReactComponents/Search/content-search-results";

function SiteSearch(props) {
    const initialCurrentIndex = useMemo(() => {
        if (
            typeof props.TotalResults === "undefined" &&
            typeof props.contentSearchTotalCount === "undefined"
        ) {
            return undefined;
        }
        if (typeof props.TotalResults !== "undefined" && props.TotalResults > 0) {
            return 0; // pick first tab
        }
        if (typeof props.contentSearchTotalCount !== "undefined" && props.contentSearchTotalCount > 0) {
            return 1; // pick second tab
        }

        return undefined;
    }, [props.TotalResults, props.contentSearchTotalCount]);

    return (
        <div className="searchpage">
            <div className="searchpage-header">
                <div className="content-row">
                    <div className="searchpage-header__content">
                        <h1 className="content-header">
                            <span>{props.TitleText}</span>
                        </h1>
                        <SearchBox SearchBoxText={props.SearchBoxText} />
                    </div>
                </div>
            </div>
            <Tabs initialCurrentIndex={initialCurrentIndex}>
                <Tab
                    label={props.ProductsText}
                    labelCount={props.TotalResults === undefined ? null : "(" + props.TotalResults + ")"}
                    isDisabled={props.TotalResults == 0}
                >
                    <div className="searchpage-results">
                        <ProductSearchResults
                            emptyProductsText={props.EmptyProductsText}
                            ProductDeliveryInfo={props.ProductListData.ProductDeliveryInfo}
                        />
                    </div>
                </Tab>
                {!props.DisableSiteSearch && (
                    <Tab
                        label={props.ContentText}
                        labelCount={
                            props.contentSearchTotalCount === undefined
                                ? null
                                : "(" + props.contentSearchTotalCount + ")"
                        }
                        isDisabled={props.contentSearchTotalCount == 0}
                    >
                        <div className="searchpage-results">
                            <ContentSearchResults
                                totalCount={props.contentSearchTotalCount}
                                pageSize={props.ContentPageSize}
                                previousButtonLabel={props.PreviousButtonLabel}
                                nextButtonLabel={props.NextButtonLabel}
                                paginationIndicator={props.PaginationIndicator}
                                emptyContentText={props.EmptyContentText}
                            />
                        </div>
                    </Tab>
                )}
            </Tabs>
        </div>
    );
}

export default searchComposer(productListComposer(SiteSearch));
